<template>
	<b-row>
		<b-col md="12">
			<b-form class="position-relative p-3" @submit.prevent="okk">
				<b-row class="mt-2">
					<b-col cols="10">
						<b-form-group class="mt-2 mb-0" label-size="sm">
							<b-input-group>
								<b-input-group-prepend is-text>
									<!--												<b-icon icon="image-fill"></b-icon>-->
								</b-input-group-prepend>
								<b-form-file
									value="disabled"
									accept=".xlsx, xls"
									:placeholder="$t('excel.noChoosen')"
									:browse-text="$t('excel.choose')"
									size="sm"
									v-model="$v.form.file.$model"
									ref="file-input"
								></b-form-file>
								<b-button class="ml-3" @click="clearFiles" variant="success">Reset</b-button>
								<b-button class="ml-3" :disabled="isDisabled" variant="primary" @click="okk">Ok...
									<b-spinner v-if="load" small></b-spinner>
								</b-button>
								<b-button class="ml-3" variant="primary" size="sm">
									<a :href="`${publicPath}excel/шаблон товаров.xlsx`" disabled download style="color: white">Скачать шаблон</a><i class="fas fa-download ml-2"></i>
								</b-button>
							</b-input-group>
						</b-form-group>
						<!--					<b-spinner  variant="primary" label="Spinning"></b-spinner>-->
					</b-col>
				</b-row>
			</b-form>
			<!-- LIST -->
			<b-table
				class="mb-0"
				:selectable="selectable"
				size="lg"
				id="table-transition-example"
				ref="table"
				small
				:items="itemss"
				:fields="fields"
				:per-page="0"
				hover="hover"
				striped="striped"
				bordered="bordered"
				show-empty

			>
				<template v-slot:empty="{}">
					<p class="text-center m-0 p-2">
						{{ ("Hozircha bosh") }}
					</p>
				</template>
				<template>
					<b-tr>
						<b-th v-for="(item, index) in fields"
							  :key="index"
							  class="pl-10 pr-10">
							{{ item.index }}
						</b-th>
					</b-tr>
				</template>

				<template v-slot:cell(file)="data">

				</template>

				<template v-slot:cell(actions)="data">
					<div v-if="!selectable">
						<i
							v-if="('Delete', 'Order')"
							class="fas fa-pencil i"
							@click="openEditModal(data.item.id)"
						></i>
					</div>
				</template>

			</b-table>

		</b-col>

	</b-row>
</template>
<script lang="js">
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import OrderHeaderService from '../../../OrderHeaderService'
import {mapActions, mapState} from "vuex"
import {BOverlay} from 'bootstrapVue2'

export default {
	mixins: [validationMixin],
	/*
	* COMPONENTS */
	components: {
		BOverlay,
	},
	props: {

		selectable: {
			type: Boolean,
			default: false
		},
		mode: {
			type: String,
			default: 'create'
		},
		items: {
			type: Object,
			default: () => {
			}
		}
	},
	validations: {
		form: {
			file: {
				required
			},
		},
	},
	data() {
		return {
			publicPath: process.env.BASE_URL,
			load: false,
			busy: false,
			processing: false,
			counter: 1,
			interval: null,
			page: 0,
			limit: 20,
			itemss: [],
			form: {

				file: false,

			}
		}
	},
	computed: {
		...mapState('excel', ['fields']),
		...mapState('excel', {'ordersList': 'list', 'totalCount': 'total',}),
		isDisabled: function () {
			return !this.form.file;
		}
	},
	beforeDestroy() {
		this.clearInterval()
	},
	methods: {
		...mapActions('excel', {'getOrder': 'getList', 'getByIdOrder': 'getById'}),
		clearInterval() {
			if (this.interval) {
				clearInterval(this.interval)
				this.interval = null
			}
		},
		async okk(bvModalEvt) {
			bvModalEvt.preventDefault()
			if (this.mode === "create") {
				this.load = true
				setTimeout(async () => {
					// send login request
					OrderHeaderService.create(this.form).then(res => {
						this.tableRefresh()
						this.itemss = res.data
					});
					this.load = false
				}, 2000);

			} else if (this.mode === 'edit') {
				await OrderHeaderService.update(this.form);
			}

		},
		tableRefresh() {
			setTimeout(() => {
				this.$refs.table.refresh();
			}, 1000);
		},
		clearFiles() {
			this.$refs['file-input'].reset()
			this.itemss = null
		},
		validateState(name) {
			const {$dirty, $error} = this.$v.form[name];
			return $dirty ? !$error : null;
		},
		checkValidity() {
			this.$v.form.$touch();
			if (this.$v.form.$anyError) {
				return true;
			} else {
				return false
			}
		}
	},
	async mounted() {
		if (this.mode == 'edit') {
			this.form = {...this.item}
		}
	},
}

</script>

<style scoped>
.box1 {
	margin-left: 103%;
	margin-top: -12%;
}

.box2 {
	margin-left: 2%;
}

</style>
